<template>
    <div class="w-100 d-flex flex-column">
        <template v-if="!$route.params.planId">
            <b-row align-v="center">
                <b-col>
                    <b-nav class="user-panel-nav-tabs">
                        <b-nav-item :to="{name: 'ReplenishmentShipments'}"
                                    active-class="active">Replenishment shipments
                        </b-nav-item>
                        <b-nav-item :to="{name: 'ReplenishmentPlans'}"
                                    active-class="active">Replenishment planning
                        </b-nav-item>
                        <!-- <b-nav-item :to="{name: 'ReplenishmentTroubles'}"
                                    active-class="active">Incoming shipments troubles
                        </b-nav-item> -->
                    </b-nav>
                </b-col>
                <b-col class="text-right">
                    <b-btn class="ml-auto"
                           variant="primary-user"
                           size="sm"
                           @click="createPlan">
                        Create a new Shipping plan
                    </b-btn>
                </b-col>
            </b-row>
        </template>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: 'MainReplenishment',
        beforeRouteUpdate(to, from, next) {
            if (to.params.newPlan) {
                this.createPlan()
            }
            next()
        },
        methods: {
            createPlan() {
                this.$store.dispatch('createPlan').then(response => {
                    this.$router.push({
                        name: 'ReplenishmentAddProducts',
                        params: {
                            parent: 'plans',
                            planId: response.id,
                            parentBred: {
                                route: this.$route
                            }
                        },
                        query: {
                            planNumber: response.uniqueNumber || response.id
                        }
                    })
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/UserPanel/Pages/Inventory/Replenishment/MainReplenishment.vue